import React from "react";

import SVGIcon from "web/react/components/svg-icon/svg-icon";
import { HStack } from "web/react/emo/h-stack";
import { Text } from "web/react/emo/text";
import { vars } from "web/react/emo/theme.css";
import { VStack } from "web/react/emo/v-stack";

export type ValidationRequirement = {
    description: string;
    pattern: RegExp;
};

interface RequirementProps extends ValidationRequirement {
    value: string;
}

function Requirement({ description, pattern, value }: RequirementProps): JSX.Element {
    const isFulfilled = pattern.test(value);

    return (
        <HStack align="center" spacing="xxs" dataTestId="validation-requirement">
            <SVGIcon
                name={isFulfilled ? "tick" : "close"}
                style={{
                    color: isFulfilled ? vars.colors.secondary600 : vars.colors.error650,
                }}
            />
            <Text as="span" textStyle="body-xs" color={isFulfilled ? undefined : "error"}>
                {description}
            </Text>
        </HStack>
    );
}

export interface ValidationRequirementsProps {
    requirements: ValidationRequirement[];
    title: string;
    value: string;
}

export function ValidationRequirements({
    requirements,
    title,
    value,
}: ValidationRequirementsProps): JSX.Element {
    return (
        <VStack spacing="xxs">
            <Text as="p" textStyle="body-xs">
                {title}
            </Text>
            <VStack spacing="xxs">
                {requirements.map(({ description, pattern }, index) => (
                    <Requirement
                        description={description}
                        pattern={pattern}
                        value={value}
                        key={index}
                    />
                ))}
            </VStack>
        </VStack>
    );
}
